import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { ElisClientError } from '@rossum/api-client/errors';
import { Runs, RunsQuery } from '@rossum/api-client/hooks';
import { api } from '../../../../../lib/apiClient';

export const QUERY_KEY_RUNS = 'hooks-runs';

export const useRuns = (
  query: RunsQuery = {},
  queryOptions: Omit<
    UseQueryOptions<
      Runs,
      ElisClientError,
      Runs,
      readonly [typeof QUERY_KEY_RUNS, typeof query]
    >,
    'queryKey' | 'queryFn'
  > = {}
) => {
  return useQuery({
    queryKey: [QUERY_KEY_RUNS, query] as const,
    queryFn: () => api.request(endpoints.hooks.runs(query)),
    cacheTime: 0,
    // Auto-refetch is disabled - handled by useRunsStatusPolling and useNewActivitiesCheck hooks
    ...queryOptions,
  });
};
